module.exports = __webpack_public_path__ + "img/id.9084ab07.svg";